import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Siempre quedaba atrás en la misma cuesta. En tres semanas llegué a la cima con el grupo. La diferencia entre tener un sistema y no tenerlo es brutal.',
    name: 'Marcelo G.',
    age: 44,
    city: 'Buenos Aires'
  }, {
    quote: 'Con el Tomo 3 entendí exactamente qué comer y cuándo. Nunca más me quedé sin energía en los últimos 20 kilómetros.',
    name: 'Diego R.',
    age: 38,
    city: 'Córdoba'
  }, {
    quote: 'Todo adaptado a Argentina. Precios reales, rutas reales, productos que conseguís en cualquier supermercado.',
    name: 'Pablo M.',
    age: 51,
    city: 'Mendoza'
  }, {
    quote: 'Pinché a 35 kilómetros de casa, cambié la cámara en 4 minutos y seguí. Antes eso me arruinaba la rodada entera.',
    name: 'Federico S.',
    age: 47,
    city: 'Rosario'
  }, {
    quote: 'Tengo 52 años y pensé que ya no podía mejorar. Con el plan de 7 días arranqué a ver cambios desde la primera salida. Mi señora no lo podía creer.',
    name: 'Carlos T.',
    age: 52,
    city: 'Tucumán'
  }];
  return <section className="bg-gray-900 text-white py-16 px-4" data-id="element-190">
      <div className="max-w-6xl mx-auto" data-id="element-191">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-192">
          LO QUE DICEN LOS QUE YA LO APLICARON
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-193">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-800 border border-gray-700 rounded-lg p-6 hover:border-green-500 transition-colors duration-300" data-id="element-194">
              <p className="text-gray-300 mb-4 italic" data-id="element-195">"{testimonial.quote}"</p>
              <div className="border-t border-gray-700 pt-4" data-id="element-196">
                <p className="font-bold" data-id="element-197">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-198">
                  {testimonial.age} años · {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}